import {
  ALL_OPERATIONS,
  LISTING_FAQ_DEPARTMENTS,
  LISTING_FAQ_OPERATIONS,
  WEB_URL,
} from "../../constants/listing-faqs-constants";

export const getDepartment = (value) =>
  LISTING_FAQ_DEPARTMENTS.find((department) => department.value === value);

export const getCity = (departmentValue, cityValue) =>
  getDepartment(departmentValue)?.cities.find(
    (city) => city.value === cityValue,
  );

// Página inicial al cambiar de departamento: su primera ciudad, sin barrio
export const pageForDepartment = (departmentValue, operation = "venta") => ({
  department: departmentValue,
  city: getDepartment(departmentValue)?.cities[0]?.value ?? null,
  zone: null,
  operation,
});

// Una página está completa cuando tiene todo lo que exige su departamento
export const isCompletePage = (page) => {
  const department = getDepartment(page?.department);
  if (!department || !page.operation) return false;
  return department.cities.length === 0 || Boolean(getCity(page.department, page.city));
};

const matchesGroup = (zone, group) =>
  zone.zone === group.zone &&
  (group.subzone === undefined || zone.subzone === group.subzone);

// Barrios que se ofrecen para una ciudad: los de su grupo de zonas, más los
// extra y menos los excluidos (ver listing-faqs-constants). Una opción por
// slug (hay nombres repetidos entre Residencial y Patrimonio), por nombre.
export const zoneOptionsForPage = (zones, page) => {
  const city = getCity(page?.department, page?.city);
  if (!city?.zoneGroup) return [];

  const extra = new Set(city.extraZones ?? []);
  const excluded = new Set(city.excludedZones ?? []);
  const seen = new Set();

  return zones
    .filter(
      (zone) =>
        zone.slug &&
        !excluded.has(zone.slug) &&
        (matchesGroup(zone, city.zoneGroup) || extra.has(zone.slug)),
    )
    .filter((zone) => (seen.has(zone.slug) ? false : seen.add(zone.slug)))
    .map((zone) => ({ value: zone.slug, label: zone.name }))
    .sort((a, b) => a.label.localeCompare(b.label, "es"));
};

// Ruta de la página en la web: la misma URL en la que salen las FAQs.
// "Venta y alquiler" es la página sin operación en la URL.
export const buildListingPath = ({ department, city, zone, operation }) =>
  [
    "",
    department,
    ...(city ? [city] : []),
    "inmuebles",
    ...(zone ? [zone] : []),
    ...(operation && operation !== ALL_OPERATIONS ? [operation] : []),
  ].join("/");

export const buildListingUrl = (page) => `${WEB_URL}${buildListingPath(page)}`;

// Nombre legible: "Residencial · Madrid · La Moraleja · Venta"
export const describePage = (page, zoneName) => {
  const department = getDepartment(page.department);
  const city = getCity(page.department, page.city);
  const operation = LISTING_FAQ_OPERATIONS.find(
    (option) => option.value === page.operation,
  );

  return [
    department?.label ?? page.department,
    city?.label ?? page.city,
    page.zone ? zoneName || page.zone : null,
    operation?.label ?? page.operation,
  ]
    .filter(Boolean)
    .join(" · ");
};

// Mueve el elemento `index` una posición arriba (-1) o abajo (+1)
export const moveItem = (items, index, direction) => {
  const target = index + direction;
  if (target < 0 || target >= items.length) return items;

  const next = [...items];
  [next[index], next[target]] = [next[target], next[index]];
  return next;
};
